// One pending SMS request survives the sending form's Turbo replacement.
let abortController;
let code;
let receivingInput;

export function request() {
  cancel();
  if (!("OTPCredential" in window) || !navigator.credentials) return;

  abortController = new AbortController();
  const signal = abortController.signal;
  navigator.credentials.get({ otp: { transport: ["sms"] }, signal }).then((credential) => {
    if (signal.aborted || !credential?.code) return;
    code = credential.code;
    fill();
  }).catch(() => {});
}

export function connectInput(input) {
  receivingInput = input;
  fill();
}

export function disconnectInput(input) {
  if (receivingInput === input) cancel();
}

function fill() {
  if (!code || !receivingInput) return;

  receivingInput.value = code;
  receivingInput.dispatchEvent(new Event("input", { bubbles: true }));
  code = null;
}

export function cancel() {
  abortController?.abort();
  code = null;
  receivingInput = null;
}

function cancelWithoutInput() {
  if (!document.querySelector('[data-sms-code-target~="input"]')) cancel();
}

document.addEventListener("turbo:load", cancelWithoutInput);
document.addEventListener("turbo:frame-load", cancelWithoutInput);
